'use strict';

module.exports = '2.24.0';



//////////////////
// WEBPACK FOOTER
// ./node_modules/algoliasearch-helper/src/version.js
// module id = 181
// module chunks = 0